/**
 * themes.js — Presentation theme definitions
 *
 * Each theme defines:
 *   id            — unique key used to store the active theme
 *   label         — display name shown in the UI dropdown
 *   icon          — emoji shown next to the label
 *   bg            — slide background color (hex)
 *   textColor     — primary heading / bold text color (hex)
 *   subtitleColor — secondary / body text color (hex)
 *   accentColor   — accent bars, buttons, highlights (hex)
 *   borderColor   — card borders, divider lines (hex)
 *   preview       — [bg, textColor, accentColor] used to render the 3-swatch preview chip
 *
 * These are pure JS constants — no database tables needed.
 * Imported by ShapeToolbar (dropdown) and PresentationEditor (applyTheme handler).
 */

export const THEMES = [
  {
    id: 'corporate',
    label: 'Corporate',
    icon: '🏢',
    bg: '#ffffff',
    textColor: '#1a1a1a',
    subtitleColor: '#555555',
    accentColor: '#2563EB',
    borderColor: '#E5E7EB',
    preview: ['#ffffff', '#1a1a1a', '#2563EB'],
  },
  {
    id: 'dark',
    label: 'Dark',
    icon: '🌑',
    bg: '#1a1a1a',
    textColor: '#ffffff',
    subtitleColor: '#cccccc',
    accentColor: '#8B5CF6',
    borderColor: '#374151',
    preview: ['#1a1a1a', '#ffffff', '#8B5CF6'],
  },
  {
    id: 'nature',
    label: 'Nature',
    icon: '🌿',
    bg: '#fafaf5',
    textColor: '#2d4a1e',
    subtitleColor: '#4a7c35',
    accentColor: '#16A34A',
    borderColor: '#BBF7D0',
    preview: ['#fafaf5', '#2d4a1e', '#16A34A'],
  },
  {
    id: 'warm',
    label: 'Warm',
    icon: '🔥',
    bg: '#fdf6e3',
    textColor: '#5c3317',
    subtitleColor: '#92400e',
    accentColor: '#EA580C',
    borderColor: '#FED7AA',
    preview: ['#fdf6e3', '#5c3317', '#EA580C'],
  },
  {
    id: 'ocean',
    label: 'Ocean',
    icon: '🌊',
    bg: '#e8f4f8',
    textColor: '#1a365d',
    subtitleColor: '#2c5282',
    accentColor: '#0284C7',
    borderColor: '#BAE6FD',
    preview: ['#e8f4f8', '#1a365d', '#0284C7'],
  },
  {
    id: 'minimal',
    label: 'Minimal',
    icon: '⬜',
    bg: '#ffffff',
    textColor: '#000000',
    subtitleColor: '#6B7280',
    accentColor: '#6B7280',
    borderColor: '#D1D5DB',
    preview: ['#ffffff', '#000000', '#6B7280'],
  },
];

/** Look up a theme by id. Returns undefined if not found. */
export function getThemeById(id) {
  return THEMES.find((t) => t.id === id);
}

/** The default theme applied to new presentations. */
export const DEFAULT_THEME_ID = 'corporate';
